import { Types } from '@store/types';

const initialState = [];

const CategoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_CATEGORY_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default CategoryReducer;
